module.exports = __webpack_public_path__ + "img/draw_area.e046f02d.svg";